import { ApiProductPage } from '../components/ApiProductPage';

/**
 * #115 — Admin-Seiten für die gemeterten API-Produkte aus dem CORE-`api_catalog`,
 * die bisher keine eigene Orbit-Seite hatten. Alle auf der gemeinsamen
 * `ApiProductPage`-Komponente (Status/Umsatz + Tarife + Endpoints, katalog-
 * getrieben). Produktspezifische Backends liegen extern — hier keine eigenen
 * Proxys nötig.
 */

export function GeocodeApiPage() {
  return (
    <ApiProductPage
      slug="geocode"
      title="Geocoding API"
      subtitle="Adresse ⇄ Koordinaten (Nominatim, DACH). Gemetertes Marktplatz-Produkt."
      backend="Nominatim (self-hosted, DACH-Import)"
    />
  );
}

export function TranslateApiPage() {
  return (
    <ApiProductPage
      slug="translate"
      title="Translate API"
      subtitle="Maschinelle Übersetzung (LibreTranslate). Gemetertes Marktplatz-Produkt."
      backend="LibreTranslate (extern, KEDA-autoscaled)"
    />
  );
}

export function LlmApiPage() {
  return (
    <ApiProductPage
      slug="llm"
      title="LLM API"
      subtitle="Text-Generierung / Prompts (Ollama). Gemetertes Marktplatz-Produkt."
      backend="Ollama (extern, GPU-Node)"
    />
  );
}

export function TrademarkApiPage() {
  return (
    <ApiProductPage
      slug="trademark"
      title="Trademark API"
      subtitle="Markenrecherche DPMA/EUIPO/WIPO (Domain Guard, #278). Gemetertes Produkt."
      backend="trademark-api (Nexus/Domain-Guard)"
    />
  );
}

export function PlatformApiPage() {
  return (
    <ApiProductPage
      slug="platform"
      title="Platform API"
      subtitle="Pods per API-Key self-serve verwalten (#190). Gemetertes Produkt."
      backend="Nexus Pod-Hosting-Control-Plane"
    />
  );
}
